import { AfterContentInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../service/auth.service';
import { base_host, environment, my_port, my_protocol } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.css']
})
export class CompanyDetailsComponent implements OnInit {

  errMessage = "";
  successMessage = "";
  feedbackID:string = this.route.snapshot.params.id;
  businessID: string = this.route.snapshot.params.businessID;
  authToken = localStorage.getItem('auth');
  company = [];
  users = [];
  pathUrl;
  order;
  isAverageCert = false;
  isNPSCert = false;
  subGroups = [];
  isMainUser = this.authService.getTokenData().mainUser;
  deleteLoader = false;
  currentSubGroup = "";

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    public sanitizer:DomSanitizer,
    private authService: AuthService) {

     }
  ngOnInit(): void {
    this.getBusinessDetails();
    this.fetchSubGroups();

  }

  fetchSubGroups() {
    this.http.get(environment.SUBGROUPS, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {

          //Sort res.message alphabetically
          if(res.message && res.message.length > 0){
            res.message.sort((a, b) => {
              if(a.businessName < b.businessName) { return -1; }
              if(a.businessName > b.businessName) { return 1; }
              return 0;
            });
            
          }
          this.subGroups = res.message;



          console.log(this.subGroups);

        }
        else {
          this.subGroups = [];
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }


  fetchOrderDetails() {

    this.http.get(environment.ORDER_DATA, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.order = [];
          this.isAverageCert = false;
          this.isNPSCert = false;
          this.order = res.message;
          console.log(this.order);

          for (let i = 0; i < this.order.certificates.selectedCertificates.length; i++) {
            const cert = this.order.certificates.selectedCertificates[i];

            if(cert == 'businessNPS'){
              this.isNPSCert = true;
            }

            if(cert == 'businessAverage'){
              this.isAverageCert = true;
            }
          }

        }
        else {
          var anElm = document.getElementById('notadded');
          anElm.style.display="block";
          console.log('ei ole kyseistä käyttäjää')
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })


  }

  getBusinessDetails() {

    this.http.get(environment.USER_BUSINESS, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          var company = res.message;
          this.company = company;
          this.getUsers();
          if(company[0].description_video_url){
            var url = "https://www.youtube.com/embed/" + company[0].description_video_url;
            this.pathUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            console.log(this.pathUrl)
            //Add url in src attribute
            setTimeout(() => {
            document.getElementById('video').setAttribute('src', url);
            },500)
          }
          
          this.pathUrl = null


          console.log(this.company);

        }
        else {
          var anElm = document.getElementById('notadded');
          anElm.style.display="block";
          console.log('ei ole kyseistä käyttäjää')
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }

  getUsers() {

    this.http.get(environment.USERS, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          var users = res.message;
          console.log(users, 'users', this.company)
          //Check which user is main user
          for (let i = 0; i < users.length; i++) {
            var user = users[i];
            console.log(user.email, this.company[0].email)
            var my_id = this.authService.getTokenData().userID;
            if(user._id == my_id){
              users[i].mainUser = true;
            }
            var today_epoch = new Date().getTime();
            if(user.activationTokenExpiracy){
              if(user.activationTokenExpiracy < today_epoch){
                users[i].isExpired = true;
                console.log('expired')
              }
            }
          }

          //set mainuser to first
          var mainUser = users.find(x => x.mainUser);
          var index = users.indexOf(mainUser);
          if(index != -1){
            users.splice(index, 1);
            users.unshift(mainUser);
          }

          this.users = users;
          console.log(this.users);

        }
        else {
          var anElm = document.getElementById('notadded');
          anElm.style.display="block";
          console.log('ei ole kyseistä käyttäjää')
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }

  selectSubGroup(id){
    this.currentSubGroup = id;
  }

  removeSubGroup(){
    this.deleteLoader = true;
    this.http.delete(environment.EMPLOYER_DELETE_SUBGROUP + '/' + this.currentSubGroup, this.httpOptions).subscribe(
      (res: any) => {
        this.deleteLoader = false;
        if(res.status == 200 ) {
          this.fetchSubGroups();
          console.log(res.message);
          document.getElementById('close-confirm-modal-subgroup').click();

        }
        else {
          alert('Error while deleting');
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })

  }

  openCity(evt, cityName) {
    // Declare all variables
    var i, tabcontent, tablinks;

  
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
  
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
  
    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
    }









}
